import $ from 'jquery';

const float = () => {
  const $float = $('.c-float');
  const footer = document.querySelector('footer');
  
  // 要素が存在しない場合は早期リターン
  if (!$float.length || !footer) return;

  // 閉じられたかどうかを追跡するフラグ
  let isClosed = false;

  // 閉じるボタン
  $(document).on('click', '.js-floatClose', function(e) {
    e.preventDefault();
    isClosed = true; // フラグを立てる
    $float.fadeOut();
  });

  // IntersectionObserver
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      // 閉じられている場合は何もしない
      if (isClosed) return;
      
      if (entry.isIntersecting) {
        $float.fadeOut();
      } else {
        $float.fadeIn();
      }
    });
  }, {
    root: null,
    threshold: 0,
    rootMargin: '0px'
  });

  observer.observe(footer);
  
  // クリーンアップ用に返す
  return () => observer.disconnect();
}

export default float;